// src/config.js
export const ORTHANC_BASE =
  process.env.REACT_APP_ORTHANC_BASE ||
  "/orthanc";
